const YEARS_OFFERED = 3;

/** Reporting years an operator can generate for: the current UTC year and the two before it, newest first. */
export const dac8YearOptions = (now: Date = new Date()): number[] => Array.from({ length: YEARS_OFFERED }, (_, index) => now.getUTCFullYear() - index);
